var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 159,
    viewBox: "0 0 201 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.94 83.1399C106.53 77.6999 109.4 72.5499 114.23 70.0299C116.14 69.0199 122.24 68.2699 122.98 65.9299C123.07 65.5699 123.11 65.2099 123.09 64.8399C123.06 50.8299 123.05 36.8299 123.07 22.8199C123.07 15.7799 137.99 18.2699 140.93 21.1599C142.5 22.8599 143.45 25.0399 143.64 27.3499C144.54 34.8999 143.61 43.2899 143.61 50.9299V76.4999L123.07 101.45V126.81H63.55V113.11C63.55 108.19 58.97 88.5299 56.68 83.6099C54.39 78.6899 54.39 68.8599 54.39 68.8599L58.97 59.0299H129.94",
    fill: "#41BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94 83.1399C106.53 77.6999 109.4 72.5499 114.23 70.0299C116.14 69.0199 122.24 68.2699 122.98 65.9299C123.07 65.5699 123.11 65.2099 123.09 64.8399C123.06 50.8299 123.05 36.8299 123.07 22.8199C123.07 15.7799 137.99 18.2699 140.93 21.1599C142.5 22.8599 143.45 25.0399 143.64 27.3499C144.54 34.8999 143.61 43.2899 143.61 50.9299V76.4999L123.07 101.45V126.81H63.55V113.11C63.55 108.19 58.97 88.5299 56.68 83.6099C54.39 78.6899 54.39 68.8599 54.39 68.8599L58.97 59.0299H129.94",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94 83.1399C106.53 77.6999 109.4 72.5499 114.23 70.0299C116.14 69.0199 122.24 68.2699 122.98 65.9299C123.07 65.5699 123.11 65.2099 123.09 64.8399C123.06 50.8299 123.05 36.8299 123.07 22.8199C123.07 15.7799 137.99 18.2699 140.93 21.1599C142.5 22.8599 143.45 25.0399 143.64 27.3499C144.54 34.8999 143.61 43.2899 143.61 50.9299V76.4999L123.07 101.45V126.81H63.55V113.11C63.55 108.19 58.97 88.5299 56.68 83.6099C54.39 78.6899 54.39 68.8599 54.39 68.8599L58.97 59.0299H129.94",
    fill: "#41BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94 83.1399C106.53 77.6999 109.4 72.5499 114.23 70.0299C116.14 69.0199 122.24 68.2699 122.98 65.9299C123.07 65.5699 123.11 65.2099 123.09 64.8399C123.06 50.8299 123.05 36.8299 123.07 22.8199C123.07 15.7799 137.99 18.2699 140.93 21.1599C142.5 22.8599 143.45 25.0399 143.64 27.3499C144.54 34.8999 143.61 43.2899 143.61 50.9299V76.4999L123.07 101.45V126.81H63.55V113.11C63.55 108.19 58.97 88.5299 56.68 83.6099C54.39 78.6899 54.39 68.8599 54.39 68.8599L58.97 59.0299H129.94",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09999 62.98C3.33999 62.86 2.62999 63.38 2.50999 64.14C2.43999 64.56 2.56999 64.99 2.85999 65.3C4.15999 66.94 5.65999 68.4 7.32999 69.65C10.43 71.83 14 73.25 17.75 73.78C19.68 74.04 31.24 75.61 38.35 66.41C44.16 58.89 43.51 48.71 40.64 41.83C37.43 34.14 29.85 26.76 20.04 27.08C13.32 27.3 7.55999 29.12 3.21999 36.69C2.92999 37.16 3.06999 37.77 3.52999 38.07C3.70999 38.19 3.92999 38.24 4.14999 38.22C7.71999 37.6 14.09 38.63 15.61 39.16C21.83 41.35 24.97 49.95 23.43 56.43C21.33 65.28 11.44 64.74 4.08999 62.98",
    fill: "#41BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09999 62.98C3.33999 62.86 2.62999 63.38 2.50999 64.14C2.43999 64.56 2.56999 64.99 2.85999 65.3C4.15999 66.94 5.65999 68.4 7.32999 69.65C10.43 71.83 14 73.25 17.75 73.78C19.68 74.04 31.24 75.61 38.35 66.41C44.16 58.89 43.51 48.71 40.64 41.83C37.43 34.14 29.85 26.76 20.04 27.08C13.32 27.3 7.55999 29.12 3.21999 36.69C2.92999 37.16 3.06999 37.77 3.52999 38.07C3.70999 38.19 3.92999 38.24 4.14999 38.22C7.71999 37.6 14.09 38.63 15.61 39.16C21.83 41.35 24.97 49.95 23.43 56.43C21.33 65.28 11.44 64.74 4.08999 62.98",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09999 62.98C3.33999 62.86 2.62999 63.38 2.50999 64.14C2.43999 64.56 2.56999 64.99 2.85999 65.3C4.15999 66.94 5.65999 68.4 7.32999 69.65C10.43 71.83 14 73.25 17.75 73.78C19.68 74.04 31.24 75.61 38.35 66.41C44.16 58.89 43.51 48.71 40.64 41.83C37.43 34.14 29.85 26.76 20.04 27.08C13.32 27.3 7.55999 29.12 3.21999 36.69C2.92999 37.16 3.06999 37.77 3.52999 38.07C3.70999 38.19 3.92999 38.24 4.14999 38.22C7.71999 37.6 14.09 38.63 15.61 39.16C21.83 41.35 24.97 49.95 23.43 56.43C21.33 65.28 11.44 64.74 4.08999 62.98H4.09999Z",
    fill: "#41BBE8",
    stroke: "black",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.04 65.2099C197.61 65.1099 198.16 65.4999 198.25 66.0799C198.3 66.41 198.2 66.7399 197.98 66.9799C196.49 68.8999 194.76 70.6199 192.84 72.1099C189.75 74.2999 186.17 75.7099 182.42 76.2399C180.49 76.4999 168.93 78.07 161.82 68.8699C156.01 61.3499 156.66 51.1699 159.53 44.2899C162.74 36.5999 170.32 29.2199 180.14 29.5399C185.42 29.8699 190.39 32.1799 194.04 36.0199C195.6 37.5899 194.64 40.4299 192.5 40.4999C189.82 40.5699 187.16 40.9499 184.56 41.6199C178.34 43.8099 175.2 52.4199 176.74 58.8899C178.93 68.1099 189.68 67.1299 197.04 65.2099Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.04 65.2099C197.61 65.1099 198.16 65.4999 198.25 66.0799C198.3 66.41 198.2 66.7399 197.98 66.9799C196.49 68.8999 194.76 70.6199 192.84 72.1099C189.75 74.2999 186.17 75.7099 182.42 76.2399C180.49 76.4999 168.93 78.07 161.82 68.8699C156.01 61.3499 156.66 51.1699 159.53 44.2899C162.74 36.5999 170.32 29.2199 180.14 29.5399C185.42 29.8699 190.39 32.1799 194.04 36.0199C195.6 37.5899 194.64 40.4299 192.5 40.4999C189.82 40.5699 187.16 40.9499 184.56 41.6199C178.34 43.8099 175.2 52.4199 176.74 58.8899C178.93 68.1099 189.68 67.1299 197.04 65.2099Z",
    fill: "#41BBE8",
    stroke: "black",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65 127.85H54.39V154.89H127.65V127.85Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65 127.85H54.39V154.89H127.65V127.85Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8 155.83H143.68",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7 49.2C60.29 49.2 56.69 45.33 56.69 40.6V23.39C56.69 18.66 60.3 14.79 64.7 14.79C69.1 14.79 72.71 18.66 72.71 23.39V40.6C72.71 45.33 69.1 49.2 64.7 49.2Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7 49.2C60.29 49.2 56.69 45.33 56.69 40.6V23.39C56.69 18.66 60.3 14.79 64.7 14.79C69.1 14.79 72.71 18.66 72.71 23.39V40.6C72.71 45.33 69.1 49.2 64.7 49.2Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72 54.12C76.31 54.12 72.71 50.25 72.71 45.52V13.56C72.71 8.82996 76.32 4.95996 80.72 4.95996C85.12 4.95996 88.73 8.82996 88.73 13.56V45.52C88.73 50.25 85.12 54.12 80.72 54.12Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72 54.12C76.31 54.12 72.71 50.25 72.71 45.52V13.56C72.71 8.82996 76.32 4.95996 80.72 4.95996C85.12 4.95996 88.73 8.82996 88.73 13.56V45.52C88.73 50.25 85.12 54.12 80.72 54.12Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06 49.2C110.65 49.2 107.05 45.33 107.05 40.6V16.02C107.05 11.29 110.66 7.42004 115.06 7.42004C119.46 7.42004 123.07 11.29 123.07 16.02V40.6C123.07 45.33 119.46 49.2 115.06 49.2Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06 49.2C110.65 49.2 107.05 45.33 107.05 40.6V16.02C107.05 11.29 110.66 7.42004 115.06 7.42004C119.46 7.42004 123.07 11.29 123.07 16.02V40.6C123.07 45.33 119.46 49.2 115.06 49.2Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75 56.57C92.34 56.57 88.74 52.7 88.74 47.97V11.1C88.74 6.37 92.35 2.5 96.75 2.5C101.15 2.5 104.76 6.37 104.76 11.1V47.97C104.76 52.7 101.15 56.57 96.75 56.57Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75 56.57C92.34 56.57 88.74 52.7 88.74 47.97V11.1C88.74 6.37 92.35 2.5 96.75 2.5C101.15 2.5 104.76 6.37 104.76 11.1V47.97C104.76 52.7 101.15 56.57 96.75 56.57Z",
    fill: "#41BBE8",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.71 39.24C44.41 39.15 49.14 39.24 53.85 39.24H162.36C161.74 39.24 159.89 44.13 159.63 44.79C158.72 47.07 158.12 49.4699 157.84 51.9099C157.57 54.3099 157.59 56.7299 157.93 59.1199C158.28 61.5999 159.53 63.9499 159.86 66.3099C158.07 66.9099 155.98 66.41 154.13 66.41H52.31C50.18 66.41 48.04 66.38 45.91 66.37C43.94 66.37 41.56 66.7899 39.66 66.3499C42.86 58.4099 44.1 49.3999 41.17 41.1199C40.95 40.3199 40.43 39.65 39.71 39.24Z",
    fill: "#41BBE8",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.77,
    height: 158.33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeBuild);
export default __webpack_public_path__ + "static/media/WeBuild.3a631c6c5bb4f8c402582944c94e55d7.svg";
export { ForwardRef as ReactComponent };